import React, { useState } from "react";
import { Col, Row, Modal, ModalBody, Input, Label } from "reactstrap";
import { Link } from "react-router-dom";

//jobImages

import sailfish from "../../assets/images/fish_types/sailfish.png";
import yellowFinTuna from "../../assets/images/fish_types/yellowfin_tuna.png";
import swordFish from "../../assets/images/fish_types/sword_fish.png";
import bigEyeTuna from "../../assets/images/fish_types/big_eye_tuna.png";

import { Box, Button, Typography, TextField, Grid } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  p: 4,
};

const RecentJobs = () => {
  const [qualityGrade, setQualityGrade] = useState("A+");
  const [remarks, setRemarks] = useState("");
  const [price, setPrice] = useState(1000);

  const [open2, setOpen2] = useState(false);

  const handleOpen2 = () => {
    setOpen2(true);
  };

  const handleClose2 = () => setOpen2(false);

  const handleUpdate = () => {
    // Perform update logic here
    console.log("Updated Quality:", { qualityGrade, remarks, price });
    alert("Quality updated successfully!");
    handleClose2();
  };

  const recentJob = [
    {
      id: 1,
      companyImg: yellowFinTuna,
      jobDescription: "Yellow Fin Tuna",
      companyName: "Boat Owner Name",
      location: "Beruwala Harbor",
      price: "1000/kg",
      fullTime: true,
      catogary: "Recent Stocks",
      quantity: "200kg",
      addclassNameBookmark: false,
      vesselNumber: "IMULA0790CHW",
      badges: [
        {
          id: 1,
          badgeclassName: "bg-success-subtle text-success",
          badgeName: "",
        },
      ],
      exp: "2024-12-31",
      Notes: "A+",
    },
    {
      id: 1,
      companyImg: sailfish,
      jobDescription: "Sail Fish",
      companyName: "Boat Owner Name",
      location: "Galle Harbor",
      price: "1000/kg",
      fullTime: true,
      catogary: "Recent Stocks",
      quantity: "5000Kg",
      addclassNameBookmark: false,
      vesselNumber: "IMULA0790CHW",
      badges: [
        {
          id: 1,
          badgeclassName: "bg-success-subtle text-success",
          badgeName: "",
        },
      ],
      exp: "2024-12-31",
      Notes: "A+",
    },
    {
      id: 1,
      companyImg: swordFish,
      jobDescription: "Sword Fish",
      companyName: "Boat Owner Name",
      location: "Negombo Harbor",
      price: "1000/kg",
      fullTime: true,
      catogary: "Recent Stocks",
      quantity: "600Kg",
      addclassNameBookmark: false,
      vesselNumber: "IMULA0790CHW",
      badges: [
        {
          id: 1,
          badgeclassName: "bg-success-subtle text-success",
          badgeName: "",
        },
      ],
      exp: "2024-12-31",
      Notes: "B",
    },
    {
      id: 1,
      companyImg: bigEyeTuna,
      jobDescription: "Big Eye Tuna",
      companyName: "Boat Owner Name",
      location: "Tangalle Harbor",
      price: "1000/kg",
      fullTime: true,
      catogary: "Recent Stocks",
      quantity: "2000Kg",
      addclassNameBookmark: false,
      vesselNumber: "IMULA0790CHW",
      badges: [
        {
          id: 1,
          badgeclassName: "bg-success-subtle text-success",
          badgeName: "Fresh",
        },
      ],
      exp: "2024-12-31",
      Notes: "B+",
    },
  ];

  return (
    <React.Fragment>
      {recentJob.map((recentJobDetails, key) => (
        <div
          key={key}
          className={
            recentJobDetails.addclassNameBookmark === true
              ? "job-box bookmark-post card mt-4 shadow"
              : "job-box card mt-4 shadow"
          }
        >
          <div className="bookmark-label text-center">
            <Link to="#" className="text-white align-middle">
              <i className="mdi mdi-star"></i>
            </Link>
          </div>
          <div
            style={{
              background: "linear-gradient(135deg, #f8f9fa, #e9ecef)",
              padding: "1rem", // equivalent to p-4
            }}
            className="p-4 bg-info"
          >
            <Row className="align-items-center">
              <Col md={2}>
                <div className="text-center mb-4 mb-md-0">
                  <Link to="/company-details">
                    <img
                      src={recentJobDetails.companyImg}
                      alt=""
                      className="img-fluid rounded-3 fish-list"
                    />
                  </Link>
                </div>
              </Col>

              <Col md={3}>
                <div className="mb-2 mb-md-0">
                  <h5 className="fs-18 mb-1">
                    <Link to="/jobdetails" className="text-dark">
                      {recentJobDetails.jobDescription}
                    </Link>
                  </h5>

                  <p className="text-muted fs-14 mb-0">
                    <a href="/boatownerdetails">
                      {recentJobDetails.companyName}
                    </a>
                  </p>

                  <p className="text-muted fs-14 mb-0">
                    <a href="/vesseldetails">{recentJobDetails.vesselNumber}</a>
                  </p>
                </div>
              </Col>

              <Col md={3}>
                <div>
                  <p className="fw-bolder fs-5 text-muted mb-2">
                    {recentJobDetails.quantity}
                  </p>
                </div>
              </Col>

              <Col md={2}>
                <div>
                  <p className="fw-bolder fs-6 text-muted mb-2">
                    <span className="text-primary ">LKR :</span>
                    {recentJobDetails.price}
                  </p>
                </div>
              </Col>

              <Col md={2}>
                <div>
                  <button className="btn btn-warning" onClick={handleOpen2}>
                    Update Quality
                  </button>
                </div>
                <div>
                  <span
                    className={
                      recentJobDetails.fullTime === true
                        ? "badge bg-success-subtle text-success fs-13"
                        : recentJobDetails.partTime === true
                        ? "badge bg-danger-subtle text-danger fs-13"
                        : recentJobDetails.freelancer === true
                        ? "badge bg-primary-subtle text-primary fs-13"
                        : ""
                    }
                  >
                    {recentJobDetails.timing}
                  </span>

                  {(recentJobDetails.badges || []).map((badgeInner, key) => (
                    <span
                      className={
                        "badge " + badgeInner.badgeclassName + " fs-13"
                      }
                      key={key}
                    >
                      {badgeInner.badgeName}
                    </span>
                  ))}
                </div>
              </Col>
              <span
                style={{
                  position: "absolute",
                  top: "0px",
                  right: "0px",
                  padding: "5px",
                  borderBottomLeftRadius: "20px",
                  height: "30px",
                  width: "30px",
                  background: "green",
                }}
              ></span>
            </Row>
          </div>
          <div className="p-3 bg-light">
            <Row>
              <Col md={3}>
                <div>
                  <p className="text-muted mb-0">
                    <i className="mdi mdi-anchor  text-primary me-2"></i>{" "}
                    {recentJobDetails.location}
                  </p>
                </div>
              </Col>

              <Col lg={3} md={5}>
                {}
                <div>
                  <p className="text-muted mb-0">
                    <span className="text-dark">
                      {recentJobDetails.Notes === null ? (
                        ""
                      ) : (
                        <>
                          <i className="mdi mdi-certificate text-primary me-2"></i>
                          Quality Grade:
                        </>
                      )}
                    </span>
                    {recentJobDetails.Notes}{" "}
                  </p>
                </div>
              </Col>

              <Col md={3}>
                <div>
                  {/* <p className="text-muted mb-0">
                    <i className="mdi mdi-anchor  text-primary me-2"></i>{" "}
                    {recentJobDetails.location}
                  </p> */}
                </div>
              </Col>

              <Col lg={3} md={3}>
                <div className="text-end text-md-end">
                  <Link to="/stockdetails" className="primary-link">
                    View Details
                    <i className="mdi mdi-chevron-double-right"></i>
                  </Link>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      ))}
      {/* <div className="text-center mt-4 pt-2">
        <Link to="/joblist" className="btn btn-primary">
          View More <i className="uil uil-arrow-right"></i>
        </Link>
      </div> */}

      <Modal isOpen={open2} toggle={handleClose2} centered>
        <ModalBody>
          <div
            style={{
              marginBottom: "16px",
              fontWeight: "bold",
              fontSize: "18px",
            }}
          >
            Inspect and Update Quality
          </div>
          <Row className="mb-3">
            <Col xs={12}>
              <TextField
                label="Quality Grade"
                fullWidth
                value={qualityGrade}
                onChange={(e) => setQualityGrade(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="mb-3">
            <Col xs={12}>
              <TextField
                label="Price (LKR/kg)"
                fullWidth
                type="number"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="mb-3">
            <Col xs={12}>
              <TextField
                label="Remarks"
                fullWidth
                multiline
                rows={3}
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col xs={6}>
              <Button color="primary" onClick={handleUpdate} block>
                Save
              </Button>
            </Col>
            <Col xs={6}>
              <Button color="secondary" onClick={handleClose2} block>
                Cancel
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default RecentJobs;
